import * as React from 'react'
import styles from './index.module.scss'
import clsx from 'clsx'
import {
  Typography,
  TypographyProps,
  Tooltip,
  TooltipProps,
} from '../../components'

export interface TruncateMiddleProps
  extends Omit<TooltipProps, 'children' | 'title' | 'classes'> {
  /**
   * Tooltip title. Zero-length titles string, undefined, null and false are never displayed.
   */
  title?: React.ReactNode
  /**
   * TypgraphyProps are props for 'Typography' component
   */
  TypgraphyProps?: Omit<TypographyProps, 'children'>
  /**
   * The content of the component.
   */
  children: string
  /**
   * Truncate Ratio - is split in to two part start : end
   */
  ratio?: number
}
export const TruncateMiddle = React.forwardRef<
  HTMLDivElement,
  TruncateMiddleProps
>((props, ref) => {
  const { TypgraphyProps, children, onOpen, ratio = 0.5, ...other } = props
  let { title } = props
  const useRatio = Math.abs(ratio) > 1 ? 0.5 : Math.abs(ratio)
  const breakpoint = Math.round(children.length * useRatio)
  const textStart = children.slice(0, breakpoint)
  const textEnd = `\u200E${children.slice(breakpoint)}\u200E`
  const widthStart = `${useRatio * 100}%`
  const widthEnd = `${(1 - useRatio) * 100}%`
  const overflowRef = React.useRef<HTMLDivElement>(null)
  const [isContentOverflow, setIsContentOverflow] = React.useState(false)
  //@ts-ignore
  title = title ?? children

  return (
    <Tooltip
      onOpen={e => {
        setIsContentOverflow(
          overflowRef.current!.offsetWidth < overflowRef.current!.scrollWidth
        )
        onOpen?.(e)
      }}
      ref={ref}
      {...other}
      title={isContentOverflow ? title : ''}
    >
      <Typography
        {...TypgraphyProps}
        style={{
          // @ts-ignore
          '--widthStart': widthStart,
          '--widthEnd': widthEnd,
          ...TypgraphyProps?.style,
        }}
        className={clsx(styles.root, TypgraphyProps?.className)}
      >
        <span ref={overflowRef} className={styles.textStart}>
          {textStart}
        </span>
        <span className={styles.textEnd}>{textEnd}</span>
      </Typography>
    </Tooltip>
  )
})
TruncateMiddle.displayName = 'TruncateMiddle'
